// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"e_ZB","wrapperDark":"e__B","wrapperLight":"e_0B"};